/**
 * 简易防抖（替代 lodash.debounce）
 */
export function debounce(fn, wait = 200) {
  let timer = null;
  return function debounced(...args) {
    const ctx = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(ctx, args);
    }, wait);
  };
}
